<template>
  <div>
    <div v-if="replies.length > 0">
      <el-pagination
        :current-page.sync="currentPage"
        layout="total, prev, pager, next, jumper"
        :total="this.total"
        :page-size="this.size"
        :hide-on-single-page="true"
      >
      </el-pagination>
      <el-timeline>
        <el-timeline-item
          v-for="reply in replies"
          :key="reply.id"
          :timestamp="reply.created_at | moment('from')"
          placement="top"
        >
          <el-card class="replyBox" :title="reply.created_at">
            <router-link
              target="_blank"
              :to="{ path: '/topics/' + reply.topic_id + '#' + reply.id }"
            >
              <div v-html="reply.content"></div>
            </router-link>
            <div class="text-right secondary-font">
              <div v-if="isLoggedIn && reply.user.id === user.id">
                <el-link
                  class="secondary-font"
                  @click="deleteReply(reply.id)"
                  icon="el-icon-delete"
                  >删除</el-link
                >
              </div>
              <div v-else>
                <router-link :to="'/user/' + reply.user.id">
                  <img
                    loading="lazy"
                    :title="'用户' + reply.user.name"
                    :alt="reply.user.name"
                    class="thumbnail img-responsive"
                    :src="reply.user.avatar"
                    width="15px"
                    height="15px"
                  />
                  {{ reply.user.name }}
                </router-link>
                ⋅
                <router-link
                  :to="{ path: '/messages', query: { id: reply.user.id } }"
                >
                  <font-awesome-icon icon="envelope" />
                  私信
                </router-link>
              </div>
            </div>
          </el-card>
        </el-timeline-item>
      </el-timeline>
      <el-pagination
        :current-page.sync="currentPage"
        layout="total, prev, pager, next, jumper"
        :total="this.total"
        :page-size="this.size"
        :hide-on-single-page="true"
      >
      </el-pagination>
    </div>
    <div v-else>
      <p class="text-center">没有回复</p>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";

export default {
  props: ["id"], // user id
  data() {
    return {
      replies: [],
      // pagination related
      total: 0,
      size: 20,
      currentPage: 1
    };
  },
  computed: {
    ...mapGetters(["isLoggedIn"]),
    ...mapState(["user"])
  },
  // pagination related
  watch: {
    currentPage: function() {
      this.fetchReplies();
    }
  },
  mounted: function() {
    this.fetchReplies();
  },
  methods: {
    ...mapMutations(["updateUser"]),
    fetchReplies() {
      this.$axios
        // pagination related
        .get(`/users/${this.id}/replies?page=${this.currentPage}`)
        .then(res => {
          this.replies = res.data.data;
          this.total = res.data.meta.pagination.total;
          this.size = res.data.meta.pagination.per_page;
        });
    },
    deleteReply: function(replyId) {
      this.$confirm("确定永久删除该回复?", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$http
          .delete("/topics/" + this.id + "/replies/" + replyId)
          .then(() => {
            this.$message({
              showClose: true,
              type: "success",
              message: "删除成功"
            });
            this.fetchReplies();
          })
          .catch(() => {
            this.$message({
              type: "error",
              showClose: true,
              message: "删除不成功，请稍后再试"
            });
          });
      });
    }
  }
};
</script>
